// extracted by mini-css-extract-plugin
module.exports = {"swipeBackdrop":"swipe-modal_swipeBackdrop__M4lVf","swipeContainer":"swipe-modal_swipeContainer__3O5IK"};